var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 111.372,
    "data-name": "google docs",
    id: "google-docs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M50.623 0H7.591A7.786 7.786 0 0 0 0 7.6v96.182a7.786 7.786 0 0 0 7.6 7.6h65.8a7.786 7.786 0 0 0 7.6-7.6v-73.4L63.284 17.716Z",
    "data-name": "Path 219"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M20.247 80.996h40.5v-5.061h-40.5v5.061Zm0 10.126h30.372v-5.061H20.247Zm0-35.437v5.061h40.5v-5.062Zm0 15.186h40.5V65.81h-40.5v5.061Z",
    "data-name": "Path 220"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1c2fa",
    d: "M50.623 0v22.781a7.782 7.782 0 0 0 7.591 7.591h22.781Z",
    "data-name": "Path 221"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.f7ece6268ea41dd529d0063349e8f99f.svg";
export { ForwardRef as ReactComponent };